require('pickmeup')

$(() =>
	$(".videoChatQuestion").on("click", function ()
	{
		const muId  = $(this).data("muid"),
			  docId = $(this).data("docid");
		let url     = "";
		const cost  = $(`.doctorCost[data-doctor="${docId}"]`).data("cost");
		$("#dialog-confirm #cost").text(cost);
		$("#dialog-confirm").dialog({
			resizable: false,
			height   : "auto",
			width    : 400,
			modal    : true,
			buttons  : {
				"Перейти на страницу записи": function ()
				{
					$(this).dialog("close");
					const dt = btoa(`${$("#datepicker").val()} ${$("#timepicker").val()}`);
					if (url) {
						location.href = url;
					}
					else {
						location.href = `/video-konsultatsiya/?MU_ID=${muId}&DOC_ID=${docId}&DT=${dt}`;
					}
				},
				"Отмена"                    : function ()
				{
					$(this).dialog("close");
				}
			}
		});
		$(".ui-dialog-buttonpane button:contains('Перейти на страницу записи')").button("disable");

		$.ajax(
			{
				url     : "/video-konsultatsiya/getSchedule.php",
				type    : "post",
				dataType: "json",
				data    : {id: docId}
			}
		).done(function (data)
		{
			if (data["timetable"].length == 0) {
				$("#dialog-confirm .schedule").html("<p>Данный врач проводит консультации по индивидуальному графику.</p>" +
					"<p>Время консультации с Вами будет согласовано в индивидуальном порядке," +
					" оплата с Вашей стороны производится только после согласования времени.</p>");
				$("#datetimepicker-wrap").addClass("dnone");
				url = `/video-konsultatsiya/?MU_ID=${muId}&DOC_ID=${docId}&NOSCHEDULE=1`;
				$(".ui-dialog-buttonpane button:contains('Перейти на страницу записи')").button("enable");
				return;
			}
			else {
				$("#datetimepicker-wrap").removeClass("dnone");
				let html = "";
				for (i = 0; i < data['timetable'].length; i++) {
					for (let j = 0; j < data['timetable'][i].dayRasp.length; j++) {
						html += `<span>${data["timetable"][i].day}${data["timetable"][i].dayRasp[j]}</span><br>`;
					}
				}
				html += "<div class=\"schedule_info\">В расписании указана дата и время, на которое может быть забронировано начало консультации. Стандартная длительность консультации составляет 30 минут, в некоторых случаях длительность может быть увеличена или уменьшена (это можно уточнить у администратора клиники)</div>";
				$("#dialog-confirm .schedule").html(html);
			}

			const $schedule                 = data;
			let disableTime                 = [];
			const defaultTime               = {"minTime": "10:00", "maxTime": "18:30", "disableTimeRanges": disableTime};
			pickmeup.defaults.locales["ru"] = {
				days       : ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
				daysShort  : ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
				daysMin    : ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
				months     : ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
				monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"]
			};
			$("#timepicker").timepicker(
				{
					disableTextInput    : true,
					disableTouchKeyboard: true,
					lang                : {am: "am", pm: "pm", AM: "AM", PM: "PM", decimal: ".", mins: "мин", hr: "ч", hrs: "ч"},
					show2400            : true,
					timeFormat          : "H:i"
				}
			);
			pickmeup("#datepicker", {
				default_date  : false,
				format        : "d.m.Y",
				locale        : "ru",
				hide_on_select: true,
				render        : function (date)
				{
					if (date < oneDayBefore) {
						return {disabled: true, class_name: "date-in-past"};
					}
					return {};
				}
			});
			$("#timepicker").val("");
			$("#timepicker").timepicker("option", defaultTime);
			$("#datepicker").val("");
			pickmeup("#datepicker").destroy();
			const now        = new Date;
			var oneDayBefore = new Date;
			oneDayBefore.setDate(now.getDate() - 1);
			if ($schedule["timetable"].length) {
				$("#timepicker").hide();
				pickmeup("#datepicker", {
					default_date  : false,
					format        : "d.m.Y",
					locale        : "ru",
					hide_on_select: true,
					render        : function (date)
					{
						if (date < oneDayBefore) {
							return {disabled: true, class_name: "date-in-past"};
						}
						let day = date.getDate();
						if (day < 10) {
							day = `0${day}`;
						}
						let month = date.getMonth() + 1;
						if (month < 10) {
							month = `0${month}`;
						}
						let year       = date.getFullYear();
						let dta        = `${day}.${month}.${year}`;
						let dayEnabled = false;
						for (j = 0; j < $schedule['timetable'].length; j++) {
							if (dta == $schedule["timetable"][j].day) {
								dayEnabled = true;
								break;
							}
						}
						if (dayEnabled == false) {
							return {disabled: true, class_name: "date-in-past"};
						}
						return {};
					}
				});
				document.getElementById("datepicker").addEventListener("pickmeup-change", function (e)
				{
					$("#timepicker").show();
					disableTime    = [];
					let elem       = document.getElementById("datepicker");
					let selectDate = elem.value;
					if ($schedule["datenext"]) {
						for (index = 0; index < $schedule['datenext'].length; ++index) {
							if ($schedule["datenext"][index]["date"] == selectDate) {
								disableTime.push($schedule["datenext"][index][0]);
							}
						}
					}
					let found = false;
					for (let i = 0; i < $schedule['timetable'].length; i++) {
						if (selectDate == $schedule["timetable"][i].day) {
							if (typeof $schedule["timetable"][i].disTime !== "undefined") {
								for (let j = 0; j < $schedule['timetable'][i].disTime.length; j++) {
									disableTime.push($schedule["timetable"][i].disTime[j]);
								}
							}
							$("#timepicker").timepicker("option", {
								"minTime"          : $schedule["timetable"][i].timeFrom,
								"maxTime"          : $schedule["timetable"][i].timeTo,
								"disableTimeRanges": disableTime
							});
							found = true;
							break;
						}
					}
					if (!found) {
						$("#timepicker").timepicker("option", defaultTime);
					}
					$("#timepicker").val("");
					$("#timepicker").timepicker("show");
				});
			}
			else {
				$("#timepicker").show();
				$("#timepicker").timepicker("option", defaultTime);
				pickmeup("#datepicker", {
					default_date  : false,
					format        : "d.m.Y",
					locale        : "ru",
					hide_on_select: true,
					render        : function (date)
					{
						if (date < oneDayBefore) {
							return {disabled: true, class_name: "date-in-past"};
						}
						return {};
					}
				});
				document.getElementById("datepicker").addEventListener("pickmeup-change", function (e)
				{
					$("#timepicker").show();
					$("#timepicker").timepicker("option", defaultTime);
					$("#timepicker").val("");
					$("#timepicker").timepicker("show");
				});
			}
			pickmeup("#datepicker").show();
		});

	}));

function time_val()
{
	if (this.value != "") {
		$(".ui-dialog-buttonpane button:contains('Перейти на страницу записи')").button("enable");
	}
}

window.time_val = time_val;
